define('../app/fukit/behavior/invoke.service.method.on.event.behavior',['require','exports','module','underscore','backbone','marionette','bluebird','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Mn       = require('marionette'),
      Promise  = require('bluebird'),
      Radio    = require('backbone.radio');

  var InvokeServiceMethodOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      // service name whose method will be invoked on
      serviceName: null,

      // service method name that will be invoked
      method: null,

      // arguments to be passed to the service
      methodArguments: [],

      // listen to this view event
      eventName: 'press',

      // when specified, this model will be used to trigger event on
      targetModel: null,
      model: null,

      // when true, use first argument passed to event to resolve target model
      resolveTargetModelFromEventArguments: false,

      // function to execute when succesfully invoked method
      onMethodSuccess: null,

      // event to trigger when successfully invoked method
      onMethodSuccessEvent: null,

      // function to execute when failed to invoke method
      onMethodError: null,

      // event to trigger when failed to invoke method
      onMethodErrorEvent: null,
      showLoading: false,
    },

    initialize: function() {
      this.listenTo(this.view, this.getOption('eventName'), this.onEvent);
    },

    onEvent: function() {
      this.invokeServiceMethod.apply(this, arguments);
    },

    getTargetModel: function() {
      if (this.getOption('model')) {
        return this.getOption('model');
      }
      if (this.getOption('targetModel')) {
        return this.getOption('targetModel');
      } else if (this.getOption('resolveTargetModelFromEventArguments')) {
        return _.find(_.toArray(arguments), function(arg) {
          return arg instanceof Backbone.Model;
        });
        return arguments[0];
      } else {
        return this.view.model;
      }
    },

    invokeServiceMethod: function() {
      //prettier-ignore
      var self                 = this,
          onMethodSuccess      = this.getOption('onMethodSuccess'),
          onMethodSuccessEvent = this.getOption('onMethodSuccessEvent'),
          onMethodError        = this.getOption('onMethodError'),
          onMethodErrorEvent   = this.getOption('onMethodErrorEvent'),
          serviceName          = Mn._getValue(this.getOption('serviceName'), this),
          method               = Mn._getValue(this.getOption('method'), this),
          showLoading          = this.getOption('showLoading'),
          model                = this.getTargetModel.apply(this, arguments),
          args                 = Mn._getValue(this.getOption('methodArguments'), this, [model]) || [model];

      if (showLoading) {
        this.view.loading = true;
      }
      return Promise.try(function() {
        return Radio.request.apply(Radio, [serviceName, method].concat(args));
      })
        .then(function(resp) {
          if (onMethodSuccess) {
            onMethodSuccess.call(self, model, resp);
          }
          if (onMethodSuccessEvent) {
            self.view.trigger(onMethodSuccessEvent, model, resp);
          }
          return true;
        })
        .catch(function(e) {
          if (onMethodError) {
            onMethodError.call(self, model, e);
          }
          if (onMethodErrorEvent) {
            self.view.trigger(onMethodErrorEvent, model, e);
          }
          throw e;
        })
        .finally(function() {
          if (showLoading) {
            self.view.loading = false;
          }
        });
    },
  });

  module.exports = InvokeServiceMethodOnEventBehavior;
});

